export default {
    menuData : [
        {
            name:"Home",
            url:"home",
            iconfont:"icon-home",
            componentName:"home"
        },
        {
            name:"Status",
            url:"status",
            iconfont:"icon-status",
            twoMenu: [
                {
                    name:"WAN",
                    componentName:"wan",
                    isShowBridge:false,
                    icon:"img/nav_left/ic_status_wan_0.png",
                    iconfont:"icon-wan"
                },
                {
                    name:"LAN",
                    componentName:"lan",
                    icon:"img/nav_left/ic_status_lan_0.png",
                    iconfont:"icon-lan"
                },
                {
                    name:"Statistics",
                    componentName:"statistics",
                    icon:"img/nav_left/ic_status_statistics_0.png",
                    iconfont:"icon-statistics"
                },
                {
                    name:"WiFi Neighbor",
                    componentName:"wlanNeighbor",
                    icon:"img/nav_left/ic_wifi_tethering_0.png",
                    iconfont:"icon-neighbor"
                }
            ]
        },
        {
            name:"Basic Setup",
            url:"basicSetup",
            iconfont:"icon-basicSetup",
            twoMenu: [
                {
                    name:"LAN",
                    url:"",
                    icon:"img/nav_left/ic_basic_lan_0.png",
                    iconfont:"icon-lan",
                    thrMenu:[
                        {name:"IPv4 Configuration",componentName:"lanIPv4",isShowBridge:false},
                        {name:"IPv6 Configuration",componentName:"lanIPv6",isShowBridge:false}
                    ]
                },
                {
                    name:"WLAN",
                    url:"",
                    icon:"img/nav_left/ic_basic_WLAN_0.png",
                    iconfont:"icon-wifi",
                    thrMenu:[
                        // 双频合一菜单
                        {name:"Basic Config",componentName:"wl1Basic",isBS:true},
                        {name:"Security Setting",componentName:"wl1Security",isBS:true},
                        // 非双频合一菜单
                        {name:"Basic Config 2.4GHz", componentName:"wl1Basic",isBS:false},
                        {name:"Basic Config 5GHz", componentName:"wl0Basic",isBS:false},
                        {name:"Security Setting 2.4GHz",componentName:"wl1Security",isBS:false},
                        {name:"Security Setting 5GHz",componentName:"wl0Security",isBS:false},
                        {name:"Advanced Config 2.4GHz",componentName:"wl1Advanced"},
                        {name:"Advanced Config 5GHz",componentName:"wl0Advanced"},
                        {name:"Mesh Info 2.4GHz",componentName:"wl1MeshInfo"},
                        {name:"Mesh Setting 2.4GHz",componentName:"wl1MeshConfig"},
                        {name:"Mesh Info 5GHz",componentName:"wl0MeshInfo"},
                        {name:"Mesh Setting 5GHz",componentName:"wl0MeshConfig"},
                        {name:"Wi-Fi Repeater",componentName:"wlRepeate"}
                    ]
                },
                {
                    name:"NAT",
                    url:"",
                    icon:"img/nav_left/ic_basic_NAT_0.png",
                    iconfont:"icon-nat",
                    thrMenu:[
                        { name: "Port Forwarding", componentName:"portForward",isShowBridge:false},
                        { name: "DMZ Host", componentName:"dmzHost",isShowBridge:false},
                        { name: "ALG", componentName:"alg",isShowBridge:false}
                    ]
                },
                {
                    name:"Security",
                    url:"",
                    icon:"img/nav_left/ic_basic_Security_0.png",
                    iconfont:"icon-security",
                    thrMenu:[
                        { name: "IP Filtering", componentName:"ipFilter",isShowBridge:false},
                        { name: "MAC Filtering", componentName:"macFilter",isShowBridge:false},
                        {name:"Dos Protection",componentName:"dosProtection",isShowBridge:false},
                        {name:"Parental Controls",componentName:"parentalcontrol",isShowBridge:false}
                    ]
                },
                {
                    name:"Routing",
                    componentName:"routing",
                    isShowBridge:false,
                    icon:"img/nav_left/ic_basic_Routing_1.png",
                    iconfont:"icon-route"
                }
            ]
        },
        {
            name:"Advance Setup",
            url:"advanceSetup",
            iconfont:"icon-advanceSetup",
            twoMenu:[
                {
                    name:"WAN Service",
                    componentName:"wanService",
                    isShowBridge:false,
                    icon:"img/nav_left/ico_advance_wan_0.png",
                    iconfont:"icon-wan"
                },
                {
                    name:"Telnet Service",
                    componentName:"telnet",
                    icon:"img/nav_left/ic_advance_telnet_0.png",
                    iconfont:"icon-telnet"
                },
                {
                    name:"SSH Service",
                    componentName:"ssh",
                    icon:"img/nav_left/ic_advance_https_0.png",
                    iconfont:"icon-ssh"
                },
                {
                    name:"SNMP",
                    componentName:"snmp",
                    isShowBridge:false,
                    icon:"img/nav_left/ic_advance_device_hub_0.png",
                    iconfont:"icon-snmp"
                },
                {
                    name:"Service Ctrl",
                    componentName:"serveiceCtrl",
                    isShowBridge:false,
                    icon:"img/nav_left/ic_advance_games_0.png",
                    iconfont:"icon-acl"
                },
                {
                    name:"Mirror",
                    componentName:"mirror",
                    icon:"img/nav_left/ic_advance_airplay_0.png",
                    iconfont:"icon-mirror"
                },
                {
                    name:"Log",
                    componentName:"log",
                    icon:"img/nav_left/ic_advance_list_0.png",
                    iconfont:"icon-log"
                },
                {
                    name:"Quality of Service",
                    componentName:"qos",
                    isShowBridge:false,
                    icon:"img/nav_left/ic_advance_settings_applications_0.png",
                    iconfont:"icon-qos"
                },
            ]
        },
        {
            name:"Application",
            url:"application",
            iconfont:"icon-application",
            twoMenu:[
                {
                    name:"Storage Service",
                    url:"",
                    icon:"img/nav_left/ic_appli_device_0.png",
                    iconfont:"icon-storage",
                    thrMenu:[
                        { name: "Device Info", componentName:"deviceInfo"},
                        { name: "User Accounts", componentName:"userAccounts"},
                        { name: "Share Folder", componentName:"shareFolder"},
                        { name: "Samba Server", componentName:"samba"},
                        { name: "FTP Server", componentName:"ftpServer"},
                        {name:"FTP Client",componentName:"ftpClient"},
                        { name: "TFTP Server", componentName:"tftpServer"},
                    ]
                },
                {
                    name:"DLNA",
                    componentName:"dlna",
                    isShowBridge:false,
                    icon:"img/nav_left/ic_appli_DLNA_0.png",
                    iconfont:"icon-dlna"
                },
                {
                    name:"DDNS",
                    componentName:"ddns",
                    isShowBridge:false,
                    icon:"img/nav_left/ic_appli_DDNS_0.png",
                    iconfont:"icon-dns"
                },
                {
                    name:"UPnP",
                    componentName:"upnp",
                    isShowBridge:false,
                    icon:"img/nav_left/ic_appli_Multicast_0.png",
                    iconfont:"icon-upnp"
                },
                {
                    name:"Multicast",
                    componentName:"multicast",
                    icon:"img/nav_left/ic-manage-diagnosis_0.png",
                    iconfont:"icon-multicast"
                }
            ]
        },
        {
            name:"Management",
            url:"management",
            iconfont:"icon-management",
            twoMenu:[
                {
                    name:"Settings",
                    url:"",
                    icon:"img/nav_left/ic-manage-setting_0.png",
                    iconfont:"icon-settings",
                    thrMenu:[
                        {name:"Backup/Restore",componentName: "backup"},
                        { name: "Update Software", componentName: "update"},
                        { name: "Reset to Default", componentName:"resetDafult"}
                    ]
                },
                {
                    name:"Account Management",
                    componentName:"reloginpassword",
                    icon:"img/nav_left/ic-manage-accoun_0.png",
                    iconfont:"icon-accout"
                },
                {
                    name:"NTP",
                    componentName:"ntp",
                    icon:"img/nav_left/ic_status_arp_0.png",
                    iconfont:"icon-ntp"
                },
                {
                    name:"Tools ",
                    url:"",
                    icon:"img/nav_left/ic-manage-diagnosis_0.png",
                    iconfont:"icon-tool",
                    thrMenu:[
                        { name: "Ping Diagnosis", componentName:"ping"},
                        { name: "Trace Route Diagnosis", componentName:"traceRoute"},
                        { name: "Inform Manually", componentName:"tr069InformStatus",isShowBridge:false},
                        { name: "Schedule Reboot", componentName:"scheduleReboot"}
                    ]
                }
            ]
        }
    ]
}